import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@air/component-skeleton";
import { memo } from "react";
export const EmptyTranscriptSegmentSkeleton = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-3 p-2",
        children: [
            /*#__PURE__*/ _jsx(Skeleton, {
                className: "h-3 w-[30px]"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 py-1",
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-3.5 w-full"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-3.5 w-full"
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        className: "h-3.5 w-2/3"
                    })
                ]
            })
        ]
    }));
EmptyTranscriptSegmentSkeleton.displayName = "EmptyTranscriptSegment";
